var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNavbarClose = function SvgNavbarClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    stroke: "currentColor",
    strokeWidth: 2
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 0 33 33M0 33 33 0"
  })));
};
export { SvgNavbarClose as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMzMnIGhlaWdodD0nMzMnIHZpZXdCb3g9IjAgMCAzMyAzMyIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Zz4KICAgIDxsaW5lIHgxPSIwIiB5MT0iMCIgeDI9IjMzIiB5Mj0iMzMiIC8+CiAgICA8bGluZSB4MT0iMCIgeTE9IjMzIiB4Mj0iMzMiIHkyPSIwIiAvPgogIDwvZz4KPC9zdmc+Cg==";